import React from "react";
import Spin from "../elements/spin";
import Block from "../Block";

export default WrapperComponent => ({ loading, children, ...props }) => {
  const loader = (
    <Spin>
      <Block className="fullContain" />
    </Spin>
  );
  return (
    <WrapperComponent {...props}>
      {loading ? loader : children}
    </WrapperComponent>
  );
};



// WEBPACK FOOTER //
// ./src/components/ui-ant/LoadingContainer/index.js